module.exports = __webpack_public_path__ + "static/media/buy_req_rent_6.007548fa.png";